
















import { Component, Prop, Vue } from 'vue-property-decorator';
import TextInput from './_text.input.vue';
@Component({
  components: {
    'text-input': TextInput
  },
})
export default class InuptCCType extends Vue {

  @Prop()
  placeholder!: string;

  public cc_type= 'CC';

  public label = 'Tipo de Documento';
  public error = '';
  public icon = 'sensor_window';

  private mounted(){
    this.cc_type = this.placeholder;
  }

  onChange($text) {
    console.log($text)
      if($text.length === 0){
          this.error = 'Cedula invalida';
      } else {
        this.$emit('nChange', $text)
          this.error = '';
      }
  }

}
